import { useTranslation } from 'react-i18next';

import { SendLinkForm } from '../../../components/SendLinkForm/SendLinkForm';
import { Heading2, Paragraph } from '../../../components/Typography/Typography';
import { AuthLayout } from '../../layouts/AuthLayout';

import { textWhite } from './InvalidLoginPage.module.css';

const InvalidLoginPage = () => {
  const { t } = useTranslation('common');
  return (
    <AuthLayout>
      <div>
        <Heading2 className={textWhite} density='condensed'>
          {t('login_link_expired_title')}
        </Heading2>
        <Paragraph density='condensed'>{t('login_link_expired_body')}</Paragraph>
      </div>
      <SendLinkForm />
    </AuthLayout>
  );
};

export { InvalidLoginPage };
